import type { FaireProductEntity } from "../../entity_types/product";

export const p_4d7k3a5z2u: FaireProductEntity = {
  token: "p_4d7k3a5z2u",
  type: "product",
  name: "PLEATED WAIST BUTTON DOWN MIDI DRESS MDR5280",
  brandToken: "b_2orbuphvsb",
  brandName: "&MERCI",
  imageUrl:
    "https://cdn.faire.com/fastly/f320c2604bc108fc2284cf96a7f2733b6c1fca8b04b900bf6c99d431b9056f32.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/223f49c08dd9279f5ef5961ebeb47d60059bbe1a73ac00fa8068b9d9b228da2f.jpeg",
    "https://cdn.faire.com/fastly/16b4503bde12cf2c6acbf7c8719ac99a8c4a2651e8f23bd37f81a49cd6175576.jpeg",
    "https://cdn.faire.com/fastly/2fca494536834a7f935d461879eb947733a8daaeee86ce5359445653cc86f764.jpeg",
    "https://cdn.faire.com/fastly/8f90f53aa36cbd226bd21947bf8226ee9725202aa3e33c9e221cd2c236fd1ace.jpeg",
    "https://cdn.faire.com/fastly/11e08429adff79f7c2102ed32d23615650adc5d050b1102fd996a75065057db5.jpeg",
    "https://cdn.faire.com/fastly/1927d4dff961a899484e44346292eefe2006f8c1407ddd824ad6ff11968cafcb.jpeg",
    "https://cdn.faire.com/fastly/0dc6640840b9740b6f8a74271b367db8f047581565f003199838a65418a5628f.jpeg",
    "https://cdn.faire.com/fastly/b6e4cd9bad425536ed95bbf4ad333196ce3870cb1a9ac47dee29acaa5a8b9c79.jpeg",
    "https://cdn.faire.com/fastly/87bebf95935e013a0a454bf428d7d2c58d0f4fe74bb406879551fcabe42f9b8f.jpeg",
  ],
  priceDollars: 178.5,
  description:
    "+ Pleated waist button down midi dress\n+ Collared neckline\n+ Fitted pleated waist\n+ Long puff sleeves with buttoned cuffs\n+ Full button placket\n+ Lined\n+ Model is 5' 10.5\" 32-24-36 and wears a S",
  tags: [],
  msrpDollars: 357,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:51.177Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
